import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states/dashboard';

function createAppsSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectIsCheckoutAppActive = createSelector(
    dashboardFeatureSelector,
    (state: IDashboardState) => state.apps.isCheckoutAppActive,
  );

  const selectIsSlackWebhookActive = createSelector(
    dashboardFeatureSelector,
    (state: IDashboardState) => state.apps.isSlackWebhookActive,
  );

  const selectDeliveryMethodsList = createSelector(
    dashboardFeatureSelector,
    (state: IDashboardState) => state.apps.deliveryMethodsList,
  );

  const selectAppsSettings = createSelector(
    dashboardFeatureSelector,
    ({ apps: { isCheckoutAppActive, isSlackWebhookActive } }: IDashboardState) => ({
      apps: {
        isCheckoutAppActive,
        isSlackWebhookActive,
      },
    }),
  );

  return {
    selectIsCheckoutAppActive,
    selectIsSlackWebhookActive,
    selectDeliveryMethodsList,
    selectAppsSettings,
  };
}

export default createAppsSelectors;
